<script>
import { BTab } from "bootstrap-vue";

export default {
  extends: BTab
};
</script>